<ng-container [ngSwitch]="col?.formControlName">
  <span [ngClass]="{'has-color': workbookRow?.rowData?.[col?.id]?.color}"
    [style.background-color]="workbookRow?.rowData?.[col?.id]?.color || 'transparent'"
    [style.color]="workbookRow?.rowData?.[col.id]?.textColor || 'inherit'">

    <ng-container *ngSwitchCase="'DatePicker'">
      {{ workbookRow?.rowData?.[col?.id]?.value | localDate:'MM/DD/YYYY':false }}
    </ng-container>

    <ng-container *ngSwitchCase="'DateTimePicker'">
      {{ workbookRow?.rowData?.[col?.id]?.value | localDate:'dateTime':false }}
    </ng-container>

    <ng-container *ngSwitchCase="'Percentage'">
      {{ workbookRow?.rowData?.[col?.id]?.value }}<span *ngIf="workbookRow?.rowData?.[col?.id]?.value">%</span>
    </ng-container>

    <ng-container *ngSwitchCase="'URL'">
      <a [href]="workbookRow?.rowData?.[col?.id]?.value | url" target="_blank">
        {{ workbookRow?.rowData?.[col?.id]?.value }}
      </a>
    </ng-container>

    <ng-container *ngSwitchCase="'Phone'">
      {{ workbookRow?.rowData?.[col?.id]?.value | phoneNumber }}
    </ng-container>

    <ng-container *ngSwitchCase="'Currency'">
      {{ workbookRow?.rowData?.[col?.id]?.value | currencySymbol: null : col?.currencySymbol }}
    </ng-container>

    <ng-container *ngSwitchCase="'Multi-Line'">
      <span pTooltip="{{ workbookRow?.rowData?.[col?.id]?.value }}" tooltipPosition="top"
        style="white-space: pre-line;">
        {{ workbookRow?.rowData?.[col?.id]?.value | shorten }}
      </span>
    </ng-container>

    <ng-container *ngSwitchCase="'RichText'">
      <span pTooltip="{{ workbookRow?.rowData?.[col?.id]?.value | removeHtmlTags }}" tooltipPosition="top">
        {{ workbookRow?.rowData?.[col?.id]?.value | removeHtmlTags | shorten }}
      </span>
    </ng-container>

    <ng-container *ngSwitchCase="'EncryptedText'">
      {{ workbookRow?.rowData?.[col?.id]?.value ? '******' : '' }}
    </ng-container>

    <ng-container *ngSwitchCase="'Time'">
      {{ workbookRow?.rowData?.[col?.id]?.value | onlyTime }}
    </ng-container>

    <ng-container *ngSwitchCase="'AutoNumber'">
      @if(workbookRow?.rowData?.[col?.id]?.value) {
      {{ (col?.prefix || '') + (workbookRow?.rowData?.[col?.id]?.value || '') }}
      }
    </ng-container>

    <ng-container *ngSwitchCase="'Decimal'">
      {{ workbookRow?.rowData?.[col?.id]?.value | number:'1.0-' + col?.maxDecimalPlaces }}
    </ng-container>

    <ng-container *ngSwitchCase="'UserLookup'">
      @if(workbookRow?.rowData?.[col?.id]?.value?.UserId) {
      <span class="truncate pointer"
        (click)="openTaggedUserDetails($event, workbookRow?.rowData?.[col?.id]?.value?.UserId)">
        {{ workbookRow?.rowData?.[col?.id]?.value?.UserName }}
      </span>
      }
    </ng-container>

    <ng-container *ngSwitchCase="'FileUpload'">
      <ng-container *ngIf="workbookRow?.rowData?.[col?.id]?.value">
        <div class="p-d-flex">
          <span [pTooltip]="workbookRow?.rowData?.[col?.id]?.value[0]?.fileName" tooltipPosition="top">
            {{ workbookRow?.rowData?.[col?.id]?.value[0]?.fileName | shorten:25 }}
          </span>
          <span *ngIf="workbookRow?.rowData?.[col?.id]?.value?.length" class="p-ml-2 pointer"
            (click)="openFiles($event, workbookRow?.rowData?.[col?.id]?.value)">
            ({{ workbookRow?.rowData?.[col?.id]?.value?.length }})
          </span>
        </div>
      </ng-container>
    </ng-container>

    <ng-container *ngSwitchCase="'Picture'">
      <ng-container *ngIf="workbookRow?.rowData?.[col?.id]?.value">
        <div class="p-d-flex">
          <span [pTooltip]="workbookRow?.rowData?.[col?.id]?.value[0]?.fileName" tooltipPosition="top">
            {{ workbookRow?.rowData?.[col?.id]?.value[0]?.fileName | shorten:25 }}
          </span>
          <span *ngIf="workbookRow?.rowData?.[col?.id]?.value?.length" class="p-ml-2 pointer"
            (click)="openPics($event, workbookRow?.rowData?.[col?.id]?.value)">
            ({{ workbookRow?.rowData?.[col?.id]?.value?.length }})
          </span>
        </div>
      </ng-container>
    </ng-container>

    <ng-container *ngSwitchDefault>
      {{ workbookRow?.rowData?.[col?.id]?.value }}
    </ng-container>

  </span>
</ng-container>

<ng-container *ngIf="displayUserDetails&&selectedUser">
  <user-details-modal [display]="displayUserDetails" [selectedUserId]="selectedUser"
    (close)="closeTaggedUserDetails()"></user-details-modal>
</ng-container>
<!-- files and pics -->
<p-dialog header="File Uploaded" [(visible)]="displayFiles" [modal]="true" (onHide)="hideFileViewModal('files')"
  [style]="{width: '60vw'}">
  <div class="card">
    <p-table [value]="allFiles">
      <ng-template pTemplate="header">
        <tr>
          <th>Name</th>
          <!-- <th>Updated Date</th> -->
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-file>
        <tr>
          <td class="p-d-flex">
            <span class="pi pi-download p-mr-2 pointer" (click)="previewListingFile($event, file, true)"
              [pTooltip]="'Download: '+file?.fileName" tooltipPosition="top"></span>
            <a target="_blank" rel="noopener noreferrer" (click)="previewListingFile($event,file, false)"
              class="truncate pointer" [pTooltip]="'View: '+ file?.fileName" tooltipPosition="top">
              {{file.fileName}}</a>
          </td>
          <!-- <td></td> -->
        </tr>
      </ng-template>
    </p-table>
  </div>
  <p-footer>
    <button type="button" pButton (click)="displayFiles=false" label="Cancel" class="p-button-secondary"></button>
  </p-footer>
</p-dialog>

<p-dialog header="Picture Uploaded" [(visible)]="displayPics" [modal]="true" (onHide)="hideFileViewModal('pics')"
  [style]="{width: '60vw'}">
  <div class="card">
    <p-table [value]="allPics">
      <ng-template pTemplate="header">
        <tr>
          <th>Name</th>
          <!-- <th>Updated Date</th> -->
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-pic>
        <tr>
          <td class="p-d-flex">
            <span class="pi pi-download p-mr-2 pointer" (click)="previewListingFile($event, pic, true)"
              [pTooltip]="'Download: '+pic?.fileName" tooltipPosition="top"></span>
            <a target="_blank" rel="noopener noreferrer" (click)="previewListingFile($event,pic, false)"
              class="truncate pointer" [pTooltip]="'View: '+ pic?.fileName" tooltipPosition="top">
              {{pic.fileName}}</a>
          </td>
          <!-- <td></td> -->
        </tr>
      </ng-template>
    </p-table>
  </div>
  <p-footer>
    <button type="button" pButton (click)="displayPics=false" label="Cancel" class="p-button-secondary"></button>
  </p-footer>
</p-dialog>